var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"menu-items-block"},_vm._l((_vm.items),function(item){return (item.price != undefined)?_c('Item',{key:item.id,attrs:{"product":item}}):_c('Item2',{attrs:{"product":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }